import { Button } from 'common/Components/Button';
import { ActivedSuccessfullyIcon } from 'common/Icons';
import { useRouter } from 'common/hooks/useRouter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setAccountActivationStep } from 'redux/common/AccountActivationSlice';

const ActivedSuccessfully = () => {
  //
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { navigate } = useRouter();

  const onOK = () => {
    dispatch(setAccountActivationStep('Agreement'));
    navigate.pushLogin();
  };

  return (
    <div className="flex flex-col gap-6 items-center">
      <h1 className="text-5xl font-bold text-center text-L-success-200 mt-4">
      {t(`BrokerCode_${window.api?.BROKER_CODE}.Activation.actived_successfully_label`)}
      </h1>
      <ActivedSuccessfullyIcon />
      <span className="text-xl font-medium md:text-b2xl  text-L-primary-50 ">
      {t(`BrokerCode_${window.api?.BROKER_CODE}.Activation.actived_successfully_details`)}
      </span>
      <div className="w-full mt-12">
        <Button
          onClick={onOK}
          className="w-full bg-L-secondary-50 dark:bg-D-secobg-L-secondary-50 rounded text-L-basic dark:text-D-basic p-2 text-3xl mb-6"
        >
          {t('FormSide.UnderstoodText')}
        </Button>
      </div>
    </div>
  );
};

export default ActivedSuccessfully;
